// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Layout-Container {
  display: flex;
  overflow-x: hidden;
  flex-wrap: wrap;
}

.Main-Container {
  align-items: center;
  justify-content: space-around;
  margin: 0 !important;
  width: 100%;
  color: #2b2b2b;
  font-weight: 300;
}
@media screen and (max-width: 767px) {
  .Main-Container {
    padding-right: 20px;
    padding-left: 20px;
  }
}
@media screen and (max-width: 1823px) {
  .Main-Container {
    padding-right: 40px;
    padding-left: 40px;
  }
}
@media screen and (min-width: 1824px) {
  .Main-Container {
    margin: auto !important;
    padding-right: 8.8125rem;
    padding-left: 8.8125rem;
    max-width: 1820px;
  }
}

.Subtitle-Logo {
  margin-bottom: 4rem;
  width: 12.5rem;
}

.Subtitle-Container {
  display: flex;
  align-items: flex-end;
  justify-content: flex-end;
}
@media screen and (max-width: 767px) {
  .Subtitle-Container {
    margin-top: 4.375rem;
  }
}
@media screen and (max-width: 1823px) {
  .Subtitle-Container {
    margin: 8.75rem 3.125rem;
  }
}
@media screen and (min-width: 1824px) {
  .Subtitle-Container {
    margin: 12.5rem 3.75rem;
  }
}

.Footer {
  margin: auto;
  padding: 5rem 0;
  width: 100%;
  background: #f2f2f2;
  color: #003825;
  font-weight: 400;
  font-size: 22px;
  line-height: 32px;
}
@media (max-width: 767.98px) {
  .Footer {
    padding-bottom: 0;
  }
}
.Footer a {
  color: #00a4ff;
  transition: all 0.3s ease;
}
.Footer a:hover {
  color: #00ff7f;
}
.Footer p {
  margin-bottom: 1.5rem;
}

.Footer-Social {
  margin-bottom: 33px;
}

.Footer-Terms {
  font-size: 22px;
  line-height: 32px;
}

.footer__logo {
  height: 2.4375rem;
}

.Header {
  position: relative;
  z-index: 1000;
  padding: 3rem 0;
  width: 100%;
}
@media (max-width: 767.98px) {
  .Header {
    padding: 24px 0;
  }
}
.Header .container {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
@media (max-width: 991.98px) {
  .Header .container {
    flex-direction: column;
    justify-content: center;
  }
}

@media (max-width: 991.98px) {
  .Header-Logo {
    margin-bottom: 24px;
  }
}

.Header-Title {
  margin-bottom: 32px;
  font-weight: bold;
  font-size: 24px;
}

.logo-placeHolder {
  height: 5.5rem;
}

.Header-Link {
  color: #00a4ff;
  font-weight: 700;
  font-size: 1.5rem;
  line-height: 36px;
}
@media (max-width: 991.98px) {
  .Header-Link {
    font-size: 20px;
  }
}
.Header-Link:hover {
  text-decoration: none;
}`, "",{"version":3,"sources":["webpack://./src/layouts/MainLayout.scss","webpack://./src/assets/scss/helpers/_variable.scss","webpack://./node_modules/bootstrap/scss/mixins/_breakpoints.scss"],"names":[],"mappings":"AAGA;EACE,aAAA;EACA,kBAAA;EACA,eAAA;AAFF;;AAKA;EACE,mBAAA;EACA,6BAAA;EACA,oBAAA;EACA,WAAA;EACA,cCMqB;EDLrB,gBAAA;AAFF;AAIE;EARF;IASI,mBAAA;IACA,kBAAA;EADF;AACF;AAGE;EAbF;IAcI,mBAAA;IACA,kBAAA;EAAF;AACF;AAEE;EAlBF;IAmBI,uBAAA;IACA,wBAAA;IACA,uBAAA;IACA,iBAAA;EACF;AACF;;AAEA;EACE,mBAAA;EACA,cAAA;AACF;;AAEA;EACE,aAAA;EACA,qBAAA;EACA,yBAAA;AACF;AACE;EALF;IAMI,oBAAA;EAEF;AACF;AAAE;EATF;IAUI,wBAAA;EAGF;AACF;AADE;EAbF;IAcI,uBAAA;EAIF;AACF;;AADA;EACE,YAAA;EACA,eAAA;EACA,WAAA;EACA,mBAAA;EACA,cCpCe;EDqCf,gBAAA;EACA,eAAA;EACA,iBAAA;AAIF;AEGI;EFfJ;IAWI,iBAAA;EAKF;AACF;AAHE;EACE,cC5CO;ED6CP,yBAAA;AAKJ;AAHI;EACE,cCjDe;ADsDrB;AADE;EACE,qBAAA;AAGJ;;AACA;EACE,mBAAA;AAEF;;AACA;EACE,eAAA;EACA,iBAAA;AAEF;;AAEA;EACE,iBAAA;AACF;;AAEA;EACE,kBAAA;EACA,aC/CU;EDgDV,eAAA;EACA,WAAA;AACF;AEhCI;EF2BJ;IAOI,eAAA;EAEF;AACF;AAAE;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;AAEJ;AE1CI;EFqCF;IAMI,sBAAA;IACA,uBAAA;EAGJ;AACF;;AEhDI;EFiDJ;IAEI,mBAAA;EAEF;AACF;;AACA;EACE,mBAAA;EACA,iBAAA;EACA,eAAA;AAEF;;AACA;EACE,cAAA;AAEF;;AACA;EACE,cC9GS;ED+GT,gBAAA;EACA,iBAAA;EACA,iBAAA;AAEF;AEvEI;EFiEJ;IAOI,eAAA;EAGF;AACF;AADE;EACE,qBAAA;AAGJ","sourcesContent":["@import '../assets/scss/helpers/component';\n@import '../assets/scss/helpers/variable';\n\n.Layout-Container {\n  display: flex;\n  overflow-x: hidden;\n  flex-wrap: wrap;\n}\n\n.Main-Container {\n  align-items: center;\n  justify-content: space-around;\n  margin: 0 !important;\n  width: 100%;\n  color: $highlight-text-color;\n  font-weight: 300;\n\n  @media screen and (max-width: 767px) {\n    padding-right: 20px;\n    padding-left: 20px;\n  }\n\n  @media screen and (max-width: 1823px) {\n    padding-right: 40px;\n    padding-left: 40px;\n  }\n\n  @media screen and (min-width: 1824px) {\n    margin: auto !important;\n    padding-right: rem(141px);\n    padding-left: rem(141px);\n    max-width: 1820px;\n  }\n}\n\n.Subtitle-Logo {\n  margin-bottom: 4rem;\n  width: rem(200px);\n}\n\n.Subtitle-Container {\n  display: flex;\n  align-items: flex-end;\n  justify-content: flex-end;\n\n  @media screen and (max-width: 767px) {\n    margin-top: rem(70px);\n  }\n\n  @media screen and (max-width: 1823px) {\n    margin: rem(140px) rem(50px);\n  }\n\n  @media screen and (min-width: 1824px) {\n    margin: rem(200px) rem(60px);\n  }\n}\n\n.Footer {\n  margin: auto;\n  padding: rem(80px) 0;\n  width: 100%;\n  background: #f2f2f2;\n  color: $gbp-rich-green;\n  font-weight: 400;\n  font-size: 22px;\n  line-height: 32px;\n\n  @include media-breakpoint-down(sm) {\n    padding-bottom: 0;\n  }\n\n  a {\n    color: $gbp-blue;\n    transition: all .3s ease;\n\n    &:hover {\n      color: $gbp-electric-green;\n    }\n  }\n\n  p {\n    margin-bottom: rem(24px);\n  }\n}\n\n.Footer-Social {\n  margin-bottom: 33px;\n}\n\n.Footer-Terms {\n  font-size: 22px;\n  line-height: 32px;\n}\n\n\n.footer__logo {\n  height: rem(39px);\n}\n\n.Header {\n  position: relative;\n  z-index: $zi-header;\n  padding: rem(48px) 0;\n  width: 100%;\n\n  @include media-breakpoint-down(sm) {\n    padding: 24px 0;\n  }\n\n  .container {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n\n    @include media-breakpoint-down(md) {\n      flex-direction: column;\n      justify-content: center;\n    }\n  }\n}\n\n.Header-Logo {\n  @include media-breakpoint-down(md) {\n    margin-bottom: 24px;\n  }\n}\n\n.Header-Title {\n  margin-bottom: 32px;\n  font-weight: bold;\n  font-size: 24px;\n}\n\n.logo-placeHolder {\n  height: rem(88px);\n}\n\n.Header-Link {\n  color: $gbp-blue;\n  font-weight: 700;\n  font-size: rem(24px);\n  line-height: 36px;\n\n  @include media-breakpoint-down(md) {\n    font-size: 20px;\n  }\n\n  &:hover {\n    text-decoration: none;\n  }\n}\n","// Fonts colors\n$primary: #415a77;\n$secondary: #2e2e3a;\n$header-background: #415a77;\n$primary-green: #2afca3;\n$light-grey: #f1f4fb;\n$blue: #317af6;\n$light-blue: #89b8f1;\n$light-green: #8ebbf1;\n$border-light: #d3e1fd;\n$white: #fff;\n$sky-blue: #cad8f2;\n$green: #3cc221;\n$red: #f42b03;\n$golden: #ffe13e;\n$pink: #fd6383;\n$dark-blue: #405873;\n$dark-blue-active: #35485e;\n$pale-grey: #f8fafd;\n$table-border: #c5d5f4;\n$highlight-text-color: #2b2b2b;\n$black: #000000;\n$accent4: #fab723;\n$maroon: #bb0611;\n$dark-blue-link: #263546;\n\n\n$gbp-rich-green: #003825;\n$gbp-electric-green: #00ff7f;\n$gbp-blue: #00a4ff;\n\n$table-border: $gbp-electric-green;\n\n$font-family-base: 'MADETOMMY', Arial, sans-serif;\n$font-family-alt: 'HeadingPro', Arial, sans-serif;\n\n$grid-breakpoints: (\n  xs: 0,\n  sm: 576px,\n  md: 768px,\n  lg: 992px,\n  xl: 1200px,\n  // xxl: 1440px,\n  // xxxl: 1600px\n);\n$container-max-widths: (\n  sm: 540px,\n  md: 720px,\n  lg: 960px,\n  xl: 1140px,\n  // xxl: 1440px,\n  // xxxl: 1600px\n);\n\n\n$zi-header: 1000;\n$zi-cookie-overlay: 1100;\n","// Breakpoint viewport sizes and media queries.\n//\n// Breakpoints are defined as a map of (name: minimum width), order from small to large:\n//\n//    (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px)\n//\n// The map defined in the `$grid-breakpoints` global variable is used as the `$breakpoints` argument by default.\n\n// Name of the next breakpoint, or null for the last breakpoint.\n//\n//    >> breakpoint-next(sm)\n//    md\n//    >> breakpoint-next(sm, (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px))\n//    md\n//    >> breakpoint-next(sm, $breakpoint-names: (xs sm md lg xl))\n//    md\n@function breakpoint-next($name, $breakpoints: $grid-breakpoints, $breakpoint-names: map-keys($breakpoints)) {\n  $n: index($breakpoint-names, $name);\n  @return if($n != null and $n < length($breakpoint-names), nth($breakpoint-names, $n + 1), null);\n}\n\n// Minimum breakpoint width. Null for the smallest (first) breakpoint.\n//\n//    >> breakpoint-min(sm, (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px))\n//    576px\n@function breakpoint-min($name, $breakpoints: $grid-breakpoints) {\n  $min: map-get($breakpoints, $name);\n  @return if($min != 0, $min, null);\n}\n\n// Maximum breakpoint width. Null for the largest (last) breakpoint.\n// The maximum value is calculated as the minimum of the next one less 0.02px\n// to work around the limitations of `min-` and `max-` prefixes and viewports with fractional widths.\n// See https://www.w3.org/TR/mediaqueries-4/#mq-min-max\n// Uses 0.02px rather than 0.01px to work around a current rounding bug in Safari.\n// See https://bugs.webkit.org/show_bug.cgi?id=178261\n//\n//    >> breakpoint-max(sm, (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px))\n//    767.98px\n@function breakpoint-max($name, $breakpoints: $grid-breakpoints) {\n  $next: breakpoint-next($name, $breakpoints);\n  @return if($next, breakpoint-min($next, $breakpoints) - .02, null);\n}\n\n// Returns a blank string if smallest breakpoint, otherwise returns the name with a dash in front.\n// Useful for making responsive utilities.\n//\n//    >> breakpoint-infix(xs, (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px))\n//    \"\"  (Returns a blank string)\n//    >> breakpoint-infix(sm, (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px))\n//    \"-sm\"\n@function breakpoint-infix($name, $breakpoints: $grid-breakpoints) {\n  @return if(breakpoint-min($name, $breakpoints) == null, \"\", \"-#{$name}\");\n}\n\n// Media of at least the minimum breakpoint width. No query for the smallest breakpoint.\n// Makes the @content apply to the given breakpoint and wider.\n@mixin media-breakpoint-up($name, $breakpoints: $grid-breakpoints) {\n  $min: breakpoint-min($name, $breakpoints);\n  @if $min {\n    @media (min-width: $min) {\n      @content;\n    }\n  } @else {\n    @content;\n  }\n}\n\n// Media of at most the maximum breakpoint width. No query for the largest breakpoint.\n// Makes the @content apply to the given breakpoint and narrower.\n@mixin media-breakpoint-down($name, $breakpoints: $grid-breakpoints) {\n  $max: breakpoint-max($name, $breakpoints);\n  @if $max {\n    @media (max-width: $max) {\n      @content;\n    }\n  } @else {\n    @content;\n  }\n}\n\n// Media that spans multiple breakpoint widths.\n// Makes the @content apply between the min and max breakpoints\n@mixin media-breakpoint-between($lower, $upper, $breakpoints: $grid-breakpoints) {\n  $min: breakpoint-min($lower, $breakpoints);\n  $max: breakpoint-max($upper, $breakpoints);\n\n  @if $min != null and $max != null {\n    @media (min-width: $min) and (max-width: $max) {\n      @content;\n    }\n  } @else if $max == null {\n    @include media-breakpoint-up($lower, $breakpoints) {\n      @content;\n    }\n  } @else if $min == null {\n    @include media-breakpoint-down($upper, $breakpoints) {\n      @content;\n    }\n  }\n}\n\n// Media between the breakpoint's minimum and maximum widths.\n// No minimum for the smallest breakpoint, and no maximum for the largest one.\n// Makes the @content apply only to the given breakpoint, not viewports any wider or narrower.\n@mixin media-breakpoint-only($name, $breakpoints: $grid-breakpoints) {\n  $min: breakpoint-min($name, $breakpoints);\n  $max: breakpoint-max($name, $breakpoints);\n\n  @if $min != null and $max != null {\n    @media (min-width: $min) and (max-width: $max) {\n      @content;\n    }\n  } @else if $max == null {\n    @include media-breakpoint-up($name, $breakpoints) {\n      @content;\n    }\n  } @else if $min == null {\n    @include media-breakpoint-down($name, $breakpoints) {\n      @content;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
